import { Controller } from '@hotwired/stimulus';

// Contrôleur Stimulus pour nettoyer automatiquement le SIRET
// Supprime les espaces, tirets et caractères non numériques en temps réel
export default class extends Controller {
  static targets = ['input'];

  connect() {
    // Nettoie le SIRET au chargement si le champ a déjà une valeur
    this.normalize();
  }

  // Nettoie le SIRET pendant la saisie (événement 'input')
  normalize() {
    const input = this.inputTarget;
    const cursorPosition = input.selectionStart;
    const originalValue = input.value;

    // Supprime tous les caractères non numériques (espaces, tirets, etc.)
    let cleaned = originalValue.replace(/[^0-9]/g, '');

    // Limite à 14 chiffres maximum (longueur d'un SIRET)
    if (cleaned.length > 14) {
      cleaned = cleaned.substring(0, 14);
    }

    // Met à jour la valeur uniquement si elle a changé
    if (input.value !== cleaned) {
      input.value = cleaned;

      // Ajuste la position du curseur
      const newCursorPosition = Math.min(cursorPosition, cleaned.length);
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }
  }

  // Nettoie le SIRET lors du collage (événement 'paste')
  paste(_event) {
    // Petite pause pour laisser le navigateur insérer le texte collé
    // puis on normalise
    setTimeout(() => this.normalize(), 0);
  }
}
